import React from "react"
import { updateField } from "@app/utils/form"

const useBodyPartsActionsObserver = (currentFieldsets, { globalValues = {}}) => {
	const bodypartsValue = globalValues["physischegefaehrdungsanalyse_gefaehrdungsinfo_koerperteile"]

	let res = React.useMemo(() => {
		let newFieldsets = currentFieldsets
		if (bodypartsValue) {
			newFieldsets = updateField(
				newFieldsets,
				"physischegefaehrdungsanalyse_massnahmen_technischemassnahmen_koerperteil",
				(element) => {
					return {
						...element,
						selectAllOption: "Alle Körperteile",
						options: bodypartsValue.map(
							(value) => ({
								value,
								label: value,
								selected: false
							})
						)
					}
				}
			)

			newFieldsets = updateField(
				newFieldsets,
				"physischegefaehrdungsanalyse_massnahmen_organisatorischemassnahmen_koerperteil",
				(element) => {
					return {
						...element,
						selectAllOption: "Alle Körperteile",
						options:
							bodypartsValue.map(
								(value) => ({
									value,
									label: value,
									selected: false
								})
							)
					}
				}
			)
		}

		return {
			fieldsets: newFieldsets,
		}
	}, [
		bodypartsValue, currentFieldsets
	])

	return res
}

export default useBodyPartsActionsObserver
